export const TOOLBAR_WIDTH_V2 = 56;
export const PANEL_WIDTH = 240;
export const RIGHT_PANEL_ELEMENT_ID = 'workflow-right-panel';
export const READ_ONLY_PANEL_HEIGHT = 40;
export const AI_CHAT_PANEL_WIDTH = 320;
export const AGENT_CHAT_PANEL_WIDTH = 280;
export const AGENT_CHAT_PANEL_MAX_WIDTH = 445;
export const CREDITS_INFO_WIDTH = 224;
export const TASK_MANAGER_WIDTH = 360;
export const DUPLICATE_NODE_OFFSET_X = 10;
export const PANEL_HEADER_HEIGHT = 72;
export const CLICK_THRESHOLD = 5;
export const ZOOM_FACTOR = 2;
export const FIT_PADDING = 0.05;
export const FIGMA_EMBED_VIEWER_TOOLBAR_WIDTH = CREDITS_INFO_WIDTH;

/**
 * The tool header's geometry. Collapsed it is a card floating over the canvas, inset by reactflow's
 * panel margin so it sits as far off the top and right as the name card does off the top and left.
 * Open, it jumps in one step to the panel's top and right edges and the body unfolds below it.
 */
export const TOOL_HEADER_INSET = 15;
export const TOOL_HEADER_WIDTH = PANEL_WIDTH - TOOL_HEADER_INSET;
export const TOOL_HEADER_HEIGHT = 80;
/** The collapsed card's corners, matching the workflow name card (`AppPaper`) across the canvas. */
export const TOOL_HEADER_RADIUS_PX = 8;

/**
 * Framing a single node on the canvas — the drawer's double-click-the-name jump and the Tool panel's
 * row selection both use these, so the two surfaces land the same way.
 *
 * `JUMP_MAX_ZOOM` caps the zoom so framing one small node doesn't slam the canvas to 200%.
 */
export const JUMP_MAX_ZOOM = 0.8;
export const JUMP_DURATION_MS = 350;
export const JUMP_PADDING = 0.2;
